var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download_svg__Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".download_svg__cls-1{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__cls-1",
    d: "M2.5 26.25c0-.55.45-1 1-1h23c.55 0 1 .45 1 1s-.45 1-1 1h-23c-.55 0-1-.45-1-1ZM8.04 11.79a.996.996 0 0 1 1.41 0l5.54 5.54 5.54-5.54a.996.996 0 1 1 1.41 1.41l-6.25 6.25a.996.996 0 0 1-1.41 0L8.03 13.2a.996.996 0 0 1 0-1.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "download_svg__cls-1",
    d: "M15 2.75c.55 0 1 .45 1 1v15c0 .55-.45 1-1 1s-1-.45-1-1v-15c0-.55.45-1 1-1Z"
  })));
};

export default SvgDownload;